module.exports = __webpack_public_path__ + "static/media/gitHub.12048fae.png";